import transparentBackground from "@/assets/images/transparent.jpg";
import type { SlideFields } from "@/types/Slide";
import type { HandWritingSlideData } from "@ai-teach/types";
import { AiFillPicture } from "react-icons/ai";

interface HandWritingThumbnailProps {
  slide: SlideFields;
}

const PREVIEW_LIMIT = 2;

export function HandWritingThumbnail({ slide }: HandWritingThumbnailProps) {
  const handWritingSlideData = slide.slideData as HandWritingSlideData;
  const words = (handWritingSlideData.text ?? []).filter((word) => word.trim() !== "");
  const previewWords = words.slice(0, PREVIEW_LIMIT);
  const hiddenCount = words.length - previewWords.length;

  return (
    <div className="bg-white shadow-sm p-2 h-full flex flex-col justify-center overflow-hidden">
      {/* Image Section */}
      <div className="relative aspect-square border-2 border-accent-400 w-full flex items-center justify-center bg-gray-200 dark:bg-gray-800 rounded-lg overflow-hidden shrink-0">
        {handWritingSlideData.image?.src ? (
          <>
            <img
              src={transparentBackground}
              alt="transparent-bg"
              className="w-full h-full object-cover absolute z-0"
            />
            <img
              src={handWritingSlideData.image.src}
              alt={previewWords[0] || "image"}
              className="w-full h-full object-cover z-30"
            />
          </>
        ) : (
          <AiFillPicture className="text-gray-400 dark:text-gray-600 text-4xl" />
        )}
      </div>

      {/* Words */}
      {previewWords.length === 0 ? (
        <div className="relative overflow-hidden flex items-center justify-center py-4 mt-3 bg-white rounded-lg border-accent-400 shadow-md">
          <h2 className="text-xl font-semibold text-gray-900 tracking-tight">No Text</h2>
        </div>
      ) : (
        previewWords.map((word, index) => (
          <div
            key={`${word}-${index + 1}`}
            className="relative overflow-hidden flex items-center justify-center py-4 mt-3 bg-white rounded-lg border-accent-400 shadow-md"
          >
            <h2 className="text-xl font-semibold text-gray-900 tracking-tight truncate px-2">
              {word}
            </h2>
          </div>
        ))
      )}

      {hiddenCount > 0 && (
        <span className="mt-1 text-[10px] font-semibold text-gray-500 text-center">
          +{hiddenCount} more
        </span>
      )}
    </div>
  );
}
